var map = {
	"./2nd.png": 8866,
	"./AppScreenshots.png": 5660,
	"./Arrow.png": 3997,
	"./Beemz_Messageing_Marketing.jpg": 5102,
	"./Checked.png": 5469,
	"./Continous_Ordering.png": 4531,
	"./Engagement.png": 5989,
	"./Facebook.png": 8588,
	"./Integrated_Ai_Customer.png": 1987,
	"./KeyFeatures_BackgroundColor.png": 5682,
	"./LinkedIn.png": 7394,
	"./ManageMultiple_Dashboard.jpg": 9048,
	"./Minimal_Hardware.jpg": 440,
	"./New Stickers 100mm diameter 1.pdf": 9493,
	"./New business cards 1.pdf": 1026,
	"./New sticker 100 x 100mm 1 (1).pdf": 4512,
	"./New sticker 100 x 100mm 1.pdf": 4862,
	"./OurVision1.png": 347,
	"./OurVision2.png": 6848,
	"./Print ready A5 flyers 1.pdf": 4188,
	"./Rajesh Kumar avatar lowercase-1.png": 3679,
	"./Rajesh Kumar avatar lowercase-2.png": 9028,
	"./Rajesh Kumar avatar lowercase-3.png": 8973,
	"./Rajesh Kumar avatar lowercase-4.png": 6466,
	"./Rajesh Kumar avatar lowercase-5.png": 683,
	"./Rajesh Kumar avatar lowercase-6.png": 2352,
	"./Rajesh Kumar avatar lowercase-7.png": 7177,
	"./Rajesh Kumar avatar lowercase-8.png": 8270,
	"./Simple_Payments.png": 7562,
	"./TeamMembers1.jpg": 7505,
	"./TeamMembers2.jpg": 7894,
	"./TeamMembers3.png": 6891,
	"./TeamMembers4.jpg": 9200,
	"./TeamMembers5.jpg": 4765,
	"./Twitter.png": 1315,
	"./about_us_1.png": 8626,
	"./about_us_1_mobile.png": 5889,
	"./about_us_2.png": 7094,
	"./about_us_2_mobile.png": 3556,
	"./ai_engagement.png": 4422,
	"./ai_ordering.png": 1903,
	"./ai_ordering_icon.png": 4839,
	"./ai_powerd.png": 9530,
	"./aisha-bello.png": 4187,
	"./analytics.png": 2110,
	"./analytics_icon.png": 5336,
	"./analytics_icon_2.png": 3275,
	"./app-store.png": 3355,
	"./appscreenshots_mobile.png": 2779,
	"./arrow-down.png": 8476,
	"./background-landing-color-2.png": 8309,
	"./background-landing-color.png": 8736,
	"./background-landing.png": 3054,
	"./background_Ee.png": 8851,
	"./bakery.png": 7944,
	"./beemz-logo.png": 3947,
	"./beemz_footer.png": 1101,
	"./beemz_socials.png": 7866,
	"./blog-1.png": 8354,
	"./blog-2.png": 3497,
	"./blog-3.png": 8672,
	"./blog1.jpg": 831,
	"./blog2.jpg": 7216,
	"./blog3.png": 1917,
	"./blog4.jpg": 4982,
	"./blog5.jpg": 8147,
	"./blog6.jpg": 2868,
	"./blog7.jpg": 913,
	"./blog8.jpg": 9770,
	"./blog9.jpg": 4231,
	"./business_profile.png": 8276,
	"./business_profile_icon.png": 5986,
	"./cafe.png": 5879,
	"./cafe_cs.png": 9846,
	"./cafe_tile.png": 9844,
	"./case_study.png": 1386,
	"./case_study_more.png": 8948,
	"./chat_mockup.png": 2602,
	"./chinedu-okafor.png": 9365,
	"./click_collect_chip.png": 9864,
	"./click_connect.png": 8541,
	"./cloud_kitchen.png": 4248,
	"./contact--linkedin.png": 9986,
	"./contact--youtube.png": 869,
	"./contact-facebook.png": 3285,
	"./contact-instagram.png": 5353,
	"./contact-jiotune.png": 6753,
	"./contact-share.png": 2796,
	"./contact-watsapp.png": 6797,
	"./costValue.png": 4276,
	"./cross_icon.png": 9832,
	"./cs_1.png": 7266,
	"./cs_2.png": 1273,
	"./cs_3.png": 5520,
	"./cs_4.png": 1391,
	"./cs_5.png": 2646,
	"./cs_6.png": 61,
	"./datapoints.png": 7373,
	"./datapoints_mobile.png": 2344,
	"./datapoints_slide_1.png": 4599,
	"./datapoints_slides.png": 1432,
	"./dewi-lestari.png": 1812,
	"./disconnected.png": 9329,
	"./disconnected_mobile.png": 9244,
	"./dollar_growth.png": 5330,
	"./dot.png": 5583,
	"./double-angle-down.png": 8060,
	"./double-angle-right.png": 2180,
	"./download-symbol.png": 4743,
	"./email_footer.png": 1342,
	"./engagement_work.png": 2581,
	"./engagement_work_icon.png": 5289,
	"./ethan-walker.png": 8695,
	"./events.png": 3011,
	"./everything_works_better.png": 8779,
	"./fast_ordering.png": 6383,
	"./food_truck_cs.png": 4579,
	"./full_access.png": 3978,
	"./get-started.png": 7314,
	"./getStarted.png": 1443,
	"./google-play.png": 4394,
	"./googleplay-app-store.png": 7925,
	"./guest_ordering.png": 1723,
	"./gym.png": 9551,
	"./hiw_cafes.png": 4713,
	"./hiw_line.png": 3033,
	"./hiw_restaurants.png": 8819,
	"./hiw_retail.png": 2050,
	"./hiw_salons.png": 8449,
	"./hotel.png": 664,
	"./improve_retention.png": 2789,
	"./increase_revenue.png": 5341,
	"./inde_restaurant.png": 4604,
	"./industry_4_items.png": 2982,
	"./insights_icon.png": 4127,
	"./kwame-mensah.png": 2566,
	"./landing_hiw_grid_1.png": 2391,
	"./landing_hiw_grid_2.png": 3660,
	"./landing_hiw_grid_3.png": 1173,
	"./landing_hiw_grid_4.png": 6506,
	"./landing_logo.png": 4853,
	"./landing_page_image_1.png": 7679,
	"./landing_page_image_2.jpg": 9616,
	"./location_footer.png": 7167,
	"./logo-small.png": 2923,
	"./logo.png": 3153,
	"./lower_order.png": 1004,
	"./loyalty_icon.png": 7274,
	"./michael-carter.png": 3259,
	"./more-affordable-img-1.png": 792,
	"./multi-flatorm-bullet-symbol.png": 2707,
	"./multi_platform.png": 6535,
	"./multiflatform-img-1.png": 6358,
	"./multiflatform-img-2.png": 125,
	"./neha-verma.png": 9328,
	"./no_charge.png": 1442,
	"./online_presence.png": 805,
	"./order_at_table.png": 7121,
	"./ourValue.png": 413,
	"./our_mission.png": 1171,
	"./our_vision.png": 6793,
	"./pay_at_table.png": 7499,
	"./payments_icon.png": 2097,
	"./pdf-icon.png": 4868,
	"./pharmacy_cs.png": 2026,
	"./play-store.png": 2782,
	"./play_button.png": 9311,
	"./pooja-shah.png": 8916,
	"./pricing-mark.png": 5900,
	"./print1.png": 8846,
	"./print2.png": 6677,
	"./print3.png": 764,
	"./print4.png": 8163,
	"./print5.png": 6250,
	"./putri-maheswari.png": 304,
	"./qr_ordering.png": 6834,
	"./qr_ordering_chip.png": 1297,
	"./qr_ordering_icon.png": 9852,
	"./qr_payments.png": 5255,
	"./qr_print.png": 861,
	"./realtime-img-1-1.svg": 143,
	"./realtime-img-1.jpg": 2483,
	"./realtime-img-2.jpg": 676,
	"./realtime-img-3.png": 3449,
	"./realtime-img-4.jpg": 6290,
	"./realtime-img-5.jpg": 2639,
	"./reduce_cost.png": 7384,
	"./repeat_visits.png": 9062,
	"./restaurant.png": 4733,
	"./restaurant_growth_cs.png": 6330,
	"./retail.png": 5513,
	"./rideshare-img-1.png": 2001,
	"./right-mark-symbol.png": 1799,
	"./right-mark-with-background.png": 8650,
	"./right-up-arrow.png": 2636,
	"./right-up-mark-with-background.png": 3674,
	"./right_icon.png": 3230,
	"./rohit-sangi.png": 9703,
	"./salon.png": 1713,
	"./salon_cs.png": 2944,
	"./sandeep-rao.png": 743,
	"./search.png": 1060,
	"./setup_in_5.png": 9007,
	"./smart_qr_ordering.png": 9012,
	"./smart_qr_ordering_mobile.png": 6387,
	"./sneha-iyer.png": 9,
	"./table_turnover.png": 7696,
	"./video-2.png": 1318,
	"./video_mobile_image.jpg": 6496,
	"./vikram-singh.png": 182,
	"./watch-our-demo-bg.png": 7858,
	"./watsapp-background.jpg": 6337,
	"./zero_order_errors.png": 7905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;